import React from "react";
import { useIntl } from "react-intl";
import { CHAT_MESSAGES_LOADING } from "../../../constants/loading.constant";
import { useGlobalCore } from "../../../cores/globals";
import { LoadingSpinnerWembii } from "../LoadingSpinnerWembii";

/** Overlay sobre el área de mensajes mientras `CHAT_MESSAGES_LOADING` está activo (web + social). */
export default function ChatMessagesLoadingOverlay() {
  const { isLoading } = useGlobalCore();
  const intl = useIntl();

  if (!isLoading(CHAT_MESSAGES_LOADING)) {
    return null;
  }

  return (
    <div
      className="chat-loading-overlay"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <LoadingSpinnerWembii active size="md" />
      <span className="chat-loading-overlay__text">
        {intl.formatMessage({ id: "app.chatFacebook.updatingMsg" })}
      </span>
    </div>
  );
}
